var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuckyspan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3472_27647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.1001,
    cy: 21.8777,
    r: 16,
    fill: "url(#paint0_linear_3472_27647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7568 22.4245C34.6413 25.5197 33.549 28.4988 31.6363 30.935L20.1003 21.8779L34.7568 22.4245Z",
    fill: "#691DDF",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7573 22.4107C34.8698 19.3154 33.9995 16.264 32.2712 13.6937L20.1003 21.8779L34.7573 22.4107Z",
    fill: "#25B6C7",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2647 13.6841C30.5344 11.1152 28.0352 9.16007 25.1253 8.09888L20.1003 21.8779L32.2647 13.6841Z",
    fill: "#B425DF",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1166 8.09569C22.2061 7.03635 19.0349 6.92561 16.0576 7.77935L20.1003 21.8779L25.1166 8.09569Z",
    fill: "#E2981A",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0511 7.78122C13.0741 8.63633 10.4443 10.4119 8.53858 12.8535L20.1003 21.8779L16.0511 7.78122Z",
    fill: "#E42461",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54277 12.8482C6.63589 15.2889 5.55062 18.2706 5.44253 21.366L20.1003 21.8779L8.54277 12.8482Z",
    fill: "#BAAF16",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44225 21.374C5.33585 24.4695 6.21215 27.5192 7.94554 30.086L20.1003 21.8779L5.44225 21.374Z",
    fill: "#7223EC",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94104 30.0794C9.67303 32.6471 12.1735 34.6007 15.084 35.66L20.1003 21.8779L7.94104 30.0794Z",
    fill: "#26B3C4",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0835 35.6599C17.994 36.7193 21.1651 36.8302 24.1425 35.9765L20.1003 21.8779L15.0835 35.6599Z",
    fill: "#C231E5",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0791 35.9945C27.0602 35.1543 29.6989 33.3918 31.6168 30.9598L20.1003 21.8779L24.0791 35.9945Z",
    fill: "#F1A71A",
    stroke: "#FFECAD",
    strokeWidth: 0.444445
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5869 8.02963C25.5868 8.0296 25.5867 8.02958 25.5867 8.02956C22.3272 6.84622 18.9316 6.80305 15.8367 7.69596L14.6172 3.45609C18.7163 2.27704 23.0835 2.42596 27.0928 3.88151L25.5869 8.02963Z",
    fill: "#0F969C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0928 3.8815C23.0835 2.42595 18.7163 2.27703 14.6172 3.45608L20.2003 22.8669L27.0928 3.8815Z",
    fill: "url(#paint1_radial_3472_27647)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3472_27647)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-1_3472_27647",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0928 3.8815C23.0835 2.42595 18.7163 2.27703 14.6172 3.45608L20.2003 22.8669L27.0928 3.8815Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.0928 3.8815C23.0835 2.42595 18.7163 2.27703 14.6172 3.45608L20.2003 22.8669L27.0928 3.8815Z",
    stroke: "url(#paint2_linear_3472_27647)",
    strokeWidth: 2.22222,
    shapeRendering: "crispEdges",
    mask: "url(#path-14-inside-1_3472_27647)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3472_27647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.1002,
    cy: 21.8778,
    r: 4.44445,
    fill: "url(#paint3_linear_3472_27647)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1002,
    cy: 21.8778,
    r: 4,
    stroke: "url(#paint4_linear_3472_27647)",
    strokeWidth: 0.88889
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.3224 20.1001C22.3224 20.591 21.3275 20.989 20.1002 20.989C18.8729 20.989 17.8779 20.591 17.8779 20.1001C17.8779 19.6092 18.8729 18.989 20.1002 18.989C21.3275 18.989 22.3224 19.6092 22.3224 20.1001Z",
    fill: "url(#paint5_linear_3472_27647)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.3224 23.8781C22.3224 24.369 21.3275 24.989 20.1002 24.989C18.8729 24.989 17.8779 24.369 17.8779 23.8781C17.8779 23.3871 18.8729 24.1001 20.1002 24.1001C21.3275 24.1001 22.3224 23.3871 22.3224 23.8781Z",
    fill: "url(#paint6_linear_3472_27647)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3472_27647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.1003,
    cy: 21.8777,
    r: 12.8889,
    stroke: "white",
    strokeWidth: 0.88889
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3472_27647",
    x: 12.8394,
    y: 1.33585,
    width: 16.0311,
    height: 23.7533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.444445
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.88889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3472_27647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3472_27647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3472_27647",
    x: 13.878,
    y: 17.4333,
    width: 12.4445,
    height: 12.4445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.77778
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.88889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3472_27647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3472_27647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3472_27647",
    x: 4.98931,
    y: 6.76665,
    width: 30.2221,
    height: 30.2221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.88889,
    result: "effect1_foregroundBlur_3472_27647"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3472_27647",
    x1: 20.1001,
    y1: 5.87769,
    x2: 20.1001,
    y2: 37.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736618,
    stopColor: "#FFF06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A235"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3472_27647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7237 11.3364) rotate(-93.6763) scale(8.01679 6.6244)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505042,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3472_27647",
    x1: 15.6406,
    y1: 3.14236,
    x2: 20.5136,
    y2: 22.0039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431932,
    stopColor: "#FFE175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4AA13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3472_27647",
    x1: 20.1002,
    y1: 17.4333,
    x2: 20.1002,
    y2: 26.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8900ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679763,
    stopColor: "#A932FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8400E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3472_27647",
    x1: 20.1002,
    y1: 17.4333,
    x2: 20.1002,
    y2: 26.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EABC91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3472_27647",
    x1: 20.1002,
    y1: 18.989,
    x2: 20.1002,
    y2: 20.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3472_27647",
    x1: 20.1002,
    y1: 24.7668,
    x2: 20.1002,
    y2: 24.1001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3472_27647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5556,
    height: 35.5556,
    fill: "white",
    transform: "translate(2.22217 2.22217)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyspan);
export default __webpack_public_path__ + "static/media/luckyspan.c7d8b6be78c4629973cacac3f18cf7f6.svg";
export { ForwardRef as ReactComponent };